/* eslint-disable camelcase */
export default {
	// 评估申请录入
	application_remark: '申请备注',
	// 评估申请浏览
	application_information: '申请信息',
	basics_information: '基础信息',
	application_number: '申请单号',
	applicant_department: '申请人部门',
	service_platform: '业务所属平台',
	business_BG: '业务所属BG',
	application_date: '申请日期',
	applicant: '申请人',
	knowner: '知会人',
	remark: '备注',
	client_information: '客户信息',
	client_name: '客户名称',
	business_license: '营业执照',
	service_information: '业务信息',
	payment_days: '账期',
	limit: '额度',
	monthly_forecast_turnover: '月预测交易额',
	attachment_information: '附件信息',
	attachment_name: '附件名称',
	operation: '操作',
	// 我的申请单查询
	application_state: '申请状态',
	BG: 'BG',
	business_platform: '业务平台',
	application_period_from: '申请时间从',
	application_period_end: '申请时间至',
	query_result_list: '查询结果列表',
	client_ID: '客户ID',
	client_business_license: '客户营业执照',
	limit_myriad: '额度（万）',
	application_period: '申请时间',
	create_period: '创建时间',
	update_period: '更新时间',
	serial_number: '序号',
	UID: 'UID',
	money_type: '资金类型',
	all_limit: '总额度',
	use_limit: '可用额度',
	mteacher_account_list: '米大师账户列表',
	adjust_type: '调整类型',
	channel_center: '渠道中心',
	group_name: '集团名称',
	CAS_result_list: '额度账期列表',
	original_payment_days: '原账期',
	adjusted_payment_days: '调整后账期',
	before_adjustment_all_limitA: '调整前总额度A',
	present_limitB: '当期额度B',
	adjust_limitC: '调整额度C(手工录入的)',
	before_adjustment_all_limitD: '调整后总额度D',
	adjust_variationE: '额度变动E',
	UID_split_detail_list: 'UID拆分明细列表',
	before_adjustment_all_limit: '调整前总额度',
	present_limit: '当期额度',
	adjust_limit: '调整额度(系统加总出来)',
	before_adjustment_all_limit_limit: '调整后总额度',
	adjust_variation: '额度变动',
	synchronization_time: '同步时间',
	platformName: '业务平台',
	bgName: '业务BG',
	applyType: '申请评估类型',
	applyId: '申请单号',
	system_real_time_accounting_period: '系统实时账期',
	real_time_accounting_period: '实时账期(实时同步的米大师)',
	system_real_time_quota: '系统实时额度',
	real_time_quota: '实时额度(CAS拆分额度是基于该字段的比例拆分出的)',
	system_real_time_quota_A: '实时额度A(实时同步的米大师)',
	evaluateId: '结果单号',
	status: '状态',
	rating: '评级',
	credit_ratio: '赊销比',
	actual_consumption: '竞价-实际消耗',
	estimated_consumption: '竞价-预估消耗',
	account_balance: '账户余额',
	system_cas_payment_days: 'CAS账期(CAS系统算出的)',
	cas_payment_days: 'CAS账期',
	cas_adjust_limit_B: 'CAS额度B(CAS系统算出的)',
	proportion: '比例',
	cas_split_limit: 'CAS拆分额度',
	expected: '是否逾期',
	month_consumption: '合约-月均消耗',
	push_status: '推送状态',
	recharge_status: '充值状态'
};
